import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ImagePlus = createReactComponent("ImagePlus", ["svg", defaultAttributes, [["path", {
  d: "M21 11v8a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h8",
  key: "16dvto"
}], ["path", {
  d: "M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  key: "btlqe1"
}], ["path", {
  d: "M21 15l-5-5L5 21",
  key: "h3p7gd"
}], ["path", {
  d: "M19 2v6",
  key: "hzml92"
}], ["path", {
  d: "M22 5h-6",
  key: "pn198q"
}]]]);
export default ImagePlus;